import { axios } from '~/libs/axios';
import { ScheduledTask } from '~/types';

async function getAll() {
  const { data: scheduledTasks } =
    await axios.get<ScheduledTask[]>('/scheduled_tasks');
  return scheduledTasks;
}

async function remove(scheduledTaskId: string) {
  await axios.delete(`/scheduled_tasks/${scheduledTaskId}`);
}

export const scheduledTasksAPI = {
  getAll,
  remove,
};
